<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12" id="print-aria">
        <table
          class="
            v-datatable-light
            table
            table-bordered
            table-hover
            table-striped
            table-center
            table-sm
            table-responsive
          "
        >
          <thead>
            <tr>
              <th
                v-for="(value, key) in allArrayLogs['data.updated_at']"
                :key="key"
              >
                <template v-if="key == 0"> Title </template>
                <template v-else> {{ value }}</template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key, itemIndex) in allArrayLogs" :key="itemIndex">
              <!-- 'cccc':{{
                key
              }} -->
              <template>
                {{ item }}
                <td v-for="(value, index) in item" :key="index">
                  <!-- <template v-if="Array.isArray(value)">
                  <WDDynamicTable
                    :tableData="value"
                    :keyValue="key"
                  ></WDDynamicTable
                ></template> -->
                  <template>
                    {{ value }}
                  </template>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as authService from '../../services/auth.service'

import WDDynamicTable from '../../components/wd/WDDynamicTable.vue'
import * as logsService from '../../services/logs.service'
import { getFlattenObj, fnSnakeToTitle } from '../../services/sharedFn.service'

export default {
  name: 'quoteView',
  props: ['quoteType'],
  components: {
    WDDynamicTable
  },
  data() {
    return {
      quoteId: this.$route.params.quoteId,
      objQuoteCalculation: {},
      userData: {},
      is_spinActive: false,
      arrayObj: [],
      current: {},
      logs: {},
      logsData: [],
      allArrayLogs: {}
    }
  },
  computed: {
    columns() {
      return Number(this.logsData.length) + 1
    },
    items() {
      return this.logsData
    }
  },

  methods: {
    fnGetQuoteLog: async function () {
      try {
        this.is_spinActive = true

        const response = await logsService.single(this.quoteId)

        const { current, logs } = response.data

        const { details: logsData } = response.data.logs

        let obj = {
          data: current
        }

        // this.current = current
        // this.logs = logs
        this.logsData = logsData

        this.arrayObj.push(getFlattenObj(obj))

        if (logsData) {
          for (const element of logsData) {
            this.arrayObj.push(getFlattenObj(element))
          }
        }

        let queryResult = this.arrayObj
        let obj1 = queryResult[0]
        let obj2 = queryResult[0]
        let newTextObj = {}

        for (let k in obj1) {
          // Replace "Data as ''"
          let str1 = k.replace('data.', '').split('.').join('')
          let yy = fnSnakeToTitle(str1)

          newTextObj[k] = yy
        }

        queryResult.unshift(newTextObj)

        console.log(queryResult)

        for (let k in obj2) {
          let yy = { ...queryResult.map((x) => x[k]) }

          obj2[k] = yy
        }

        //  console.log(obj2)

        this.allArrayLogs = obj2

        this.is_spinActive = false
      } catch (error) {
        console.log(error)
      }
    },

    fnCheckValueIsArray(value) {
      return Array.isArray(value)
    },

    fnAllEqual(arr) {
      const res = new Set(arr).size === 1
      return res
    }
  },
  created() {
    this.fnGetQuoteLog(this.quoteId)
    this.userData = authService.getUserFromToken()
  }
}
</script>

<style>
@page {
  size: A4 portrait;
  margin: 0cm 0cm;
  /* width: 210mm;
        height: 290mm; */
  margin: 0px 0px 0px 0px;
}
@media print {
  body * {
    visibility: hidden !important;
  }

  #print-aria,
  #print-aria * {
    visibility: visible !important;
  }
  #print-aria {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    margin: 0;
    /* width: 210mm; */
    /* height: 297mm; */
  }
  #qQuotePage1 {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
  #qQuotePage1 footer {
    display: none;
  }
  #qQuotePage2 {
    padding-top: 10px;
    page-break-before: always;
  }

  #qQuotePage3 {
    padding-top: 10px;
    page-break-inside: avoid;
  }
  #qQuotePage3 .sectionTable0.mt-5 {
    margin-top: 0;
  }

  #qQuotePage3 .printing.mt-5 {
    margin-top: 10px !important;
  }
  #qQuotePage3 .printing.mb-5 {
    margin-top: 0px !important;
  }

  /* #print-aria:last-child {
    page-break-after: auto;
  } */

  footer.iq-footer {
    display: none !important;
  }
  [dir='ltr'] footer.iq-footer {
    display: none !important;
  }
  #newTable0 {
    /* padding-top: 30px; */
  }
  #newTable0 img {
    width: 60% !important;
    height: auto;
  }

  [dir='ltr'] .iq-footer {
    display: none;
  }
  .iq-footer {
    display: none !important;
  }

  .container-type-1 img {
    width: 95% !important;
    height: auto;
  }
}

#qQuotePage1 table td img {
  /* width:50%; */
}

#qQuotePage1 table {
  /* border-collapse: collapse;
        width: 100%; */
}

.sectionTable0 {
  border-radius: 10px;
  background-color: #ebf4ff;
}

#newTable0 img {
  max-width: 60%;
  max-height: auto;
}
#newTable0 {
  display: flex;
  flex-wrap: nowrap;
}

#newTable1 table {
  border-collapse: collapse;
  width: 80%;
  background-color: #ebf4ff;
  border-radius: 15px;
}
#newTable1 table th {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
  color: #4f5962;
  font-weight: 400;
}
#newTable1 table td {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0.5px solid #dee2e6;
  color: #4f5962;
}
#newTable1 table tr.top-line th {
  padding-top: 0.5rem;
}
#newTable1 table tr.bot-line td {
  padding-bottom: 0.5rem;
}

#newTable2 table {
  border-collapse: collapse;
  width: 100%;
  background-color: #ebf4ff;
  border-radius: 15px;
}
#newTable2 table th {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
  color: #4f5962;
}
#newTable2 table td {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0.5px solid #dee2e6;
  color: #4f5962;
}
#newTable2 table tr.top-line th {
  padding-top: 0.5rem;
}
#newTable2 table tr.bot-line td {
  padding-bottom: 0.5rem;
}

#newTable3 table {
  border-collapse: collapse;
  width: 100%;
  background-color: #ebf4ff;
  border-radius: 15px;
}
#newTable3 table th {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
  color: #4f5962;
}
#newTable3 table td {
  padding: 0.2rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
  border-top: 0.5px solid #dee2e6;
  color: #4f5962;
}
#newTable3 table tr.top-line th {
  padding-top: 0.5rem;
}
#newTable3 table tr.bot-line td {
  padding-bottom: 0.5rem;
}
#benefits-summary {
  background-color: #ebf4ff;
  padding: 1rem;
}
#benefits-summary ul li span {
  font-style: italic;
  font-weight: 900 !important;
  color: black;
  font-size: 16px;
}
#benefits-summary ul {
  list-style-type: disc !important;
}

/*
* finance-your-next-car
*
*/
.finance-your-next-car {
  display: flex;
  justify-content: space-between;
}

.finance-your-next-car .img-section {
  width: 20%;
}
.finance-your-next-car .img-section img {
  position: relative;
  width: 85%;
}
.finance-your-next-car .text-section {
  width: 78%;
}

/*
* end-of-lease
*/
.end-of-lease {
  display: flex;
  justify-content: space-between;
}
.container-type-1 img {
  height: 260px;
  width: auto;
}
.container-type-1 {
  position: relative;
  text-align: center;
}
.container-type-1 .centered {
  left: 30px;
  right: 30px;
  top: 10px;
  text-align: center;
  position: absolute;
}
.container-type-1 .subtitle {
  /* padding-left: 20px;
  padding-right: 20px; */
  line-height: 15px;
}
/*
* process-from-here
*/
.process-from-here {
  display: flex;
  justify-content: space-between;
}

/*
* Disclaimer
*/
#disclaimer {
  margin-top: 3rem;
}
#disclaimer .title {
  font-weight: 700;
  margin-bottom: 0.2rem;
}
#disclaimer .title,
#disclaimer .text {
  font-size: 0.8rem;
  line-height: 14px;
}

.txt-left {
  text-align: left;
}
.txt-right {
  text-align: right;
}
.fw-600 {
  font-weight: 600;
}
.fw-700 {
  font-weight: 700;
}
.fs-700 {
  font-size: 0.7rem;
}
.bg-info {
  background-color: var(--iq-info);
}
.text-primary {
  color: #38afef;
}

.mb-0 {
  margin-bottom: 0;
}
</style>
